import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function MediaCard({
  imageLink,
  title,
  description,
  alt,
}: {
  imageLink: string;
  title: string;
  description: string;
  alt: string;
}) {
  return (
    <Card
      sx={{
        width: '100%',
        maxWidth: 360,
        margin: '0 auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02)',
        overflow: 'hidden',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 12px 24px -4px rgba(15, 23, 42, 0.08), 0 4px 8px -2px rgba(15, 23, 42, 0.04)',
          borderColor: '#cbd5e1',
        },
      }}
    >
      <Box
        sx={{
          height: 160,
          backgroundColor: '#f8fafc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
          borderBottom: '1px solid #f1f5f9',
        }}
      >
        <CardMedia
          component="img"
          sx={{
            maxHeight: 128,
            maxWidth: '100%',
            objectFit: 'contain',
          }}
          image={require(`../../imgs/${imageLink}`)}
          alt={alt}
          title={alt}
        />
      </Box>
      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 22px 24px',
        }}
      >
        <Typography
          gutterBottom
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 600,
            fontSize: '1.15rem',
            color: '#0f172a',
            marginBottom: '8px',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: '#64748b',
            fontSize: '0.925rem',
            lineHeight: 1.6,
          }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}